module.exports = __webpack_public_path__ + "img/mail.aedcf94e.png";